// Single source for the support address. Webpack's DefinePlugin substitutes
// REACT_APP_SUPPORT_EMAIL at build time; when the variable is unset it defines
// the identifier as undefined, so read it defensively and return null rather
// than guessing an address. Callers render no support button on null: a
// mailto: link to an address nobody reads is worse than no link at all.
export function getSupportEmail() {
    if (typeof REACT_APP_SUPPORT_EMAIL === 'undefined')
        return null;
    const email = String(REACT_APP_SUPPORT_EMAIL).trim();
    return email.length > 0 ? email : null;
}
